// import API from "../../../app/api";

// export const orderPlace = async (checkoutId, payload) => {
//   try {
//     const response = await API.post(
//       `/checkout/${checkoutId}/order-place`,
//       payload
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Order Place API Error:", error);
//     throw error;
//   }
// };


import API from "../../../app/api";


export const orderPlace = async(
 checkoutId,
 payload
)=>{

 const response = await API.post(
   `/checkout/${checkoutId}/order-place`,
   payload
 );


 return response.data;

};